declare const AnnotatedBrand: unique symbol;

export type Annotated<a, v> = {
  [AnnotatedBrand]: [v, a];
};

type ExposedAnnotated<a, v> = [v, a];

function fromBrandedAnnotated<a, v>(x: Annotated<a, v>) {
  return x as unknown as ExposedAnnotated<a, v>;
}

function toBrandedAnnotated<a, v>(x: ExposedAnnotated<a, v>) {
  return x as unknown as Annotated<a, v>;
}

export function annotate<a, v>(val: v, ann: a): Annotated<a, v> {
  return toBrandedAnnotated([val, ann]);
}

export function stripAnn<a, v>(x: Annotated<a, v>): v {
  return fromBrandedAnnotated(x)[0];
}

export function getAnn<a, v>(x: Annotated<a, v>): a {
  return fromBrandedAnnotated(x)[1];
}

export function updateAnn<a, b, v>(f: (ann: a) => b) {
  return function updateAnnInner(x: Annotated<a, v>): Annotated<b, v> {
    const [val, ann] = fromBrandedAnnotated(x);
    const newAnn = f(ann);
    return newAnn === (ann as unknown as b)
      ? (x as unknown as Annotated<b, v>)
      : toBrandedAnnotated([val, newAnn]);
  };
}

export function updateVal<a, v, w>(fn: (val: v) => w) {
  return function updateSubjInner(x: Annotated<a, v>): Annotated<a, w> {
    const [val, ann] = fromBrandedAnnotated(x);
    const newVal = fn(val);
    return newVal === (val as unknown as w)
      ? (x as unknown as Annotated<a, w>)
      : toBrandedAnnotated([newVal, ann]);
  };
}
